module.exports = __webpack_public_path__ + "static/media/header1.a99a25f8.jpg";